export default __webpack_public_path__ + "static/media/landing_page_banner.6371bc50.png";